module.exports = __webpack_public_path__ + "img/mate10.132daf4c.jpg";